import React, { useContext, useState } from 'react';

import Footer from 'components/footer';
import Header from 'components/header';
import AnchorButton from 'components/anchor-button';
import MetaTags from 'components/meta-tags';

import LocaleContext from 'contexts/locale-context';

import Error from './error';
import Upload from './upload';
import Uploading from './uploading';
import Uploaded from './uploaded'

import If from 'conditionals/if';

import './index.css';


const states = {
  UPLOAD: 'UPLOAD',
  UPLOADING: 'UPLOADING',
  UPLOADED: 'UPLOADED'
};

const onUpload = (setFiles, setPassword, setState) => (files, password) => {
  setFiles(files);
  setPassword(password);
  setState(states.UPLOADING)
}

const onUploaded = (setFiles, setState, setLink, setTransferId) => (link, id) => {
  setState(states.UPLOADED)
  setFiles([]);
  setLink(link);
  setTransferId(id);
}

const onCancel = (setState) => e => {
  setState(states.UPLOAD);
}

const onError = (setState, translations) => (e = {}) => {
  if (e && !e.stopped) {
    alert(e && e.message ? e.message : translations.something_went_wrong);
    setState(states.UPLOAD);
  }
}

const Home = () => {
  const [state, setState] = useState(states.UPLOAD);
  const [link, setLink] = useState(null);
  const [files, setFiles] = useState([]);
  const [password, setPassword] = useState('');
  const [transferId, setTransferId] = useState('');
  const { locale, translations } = useContext(LocaleContext);

  const jsTranslations = translations.js;
  const commonTranslations = translations.common;
  const pageTranslations = translations.index;

  // const hasFiles = true;
  const hasFiles = files && files.length > 0;
  const hasLink = !!link;
  // const hasLink = true;

  if (state === state.UPLOADING) {
    window.onbeforeunload = function () {
      return true;
    }
  } else {
    window.onbeforeunload = function () {}
  }

  return (
    <div>
      <MetaTags description={commonTranslations.description} />
      <div className='home__header'>
        <Header>
          <If condition={state === states.UPLOADED}>
            <AnchorButton href={`/${locale}`}>{pageTranslations.send_more_files}</AnchorButton>
          </If>
        </Header>
      </div>
      <div className='container'>
        <div className='home__body'>
          {state === states.UPLOAD &&
            <Upload files={files} password={password} onUpload={onUpload(setFiles, setPassword, setState)}/>
          }

          {state === states.UPLOADING && hasFiles &&
            <Uploading
              files={files}
              password={password}
              onError={onError(setState, jsTranslations)}
              onUploaded={onUploaded(setFiles, setState, setLink, setTransferId)}
              onCancel={onCancel(setState, jsTranslations)}
            />
          }

          {state === states.UPLOADING && !hasFiles &&
            <Error message={jsTranslations.please_select_one}/>
          }

          {state === states.UPLOADED && !hasLink &&
            <Error message={jsTranslations.something_went_wrong}/>
          }

          {state === states.UPLOADED && hasLink &&
            <Uploaded link={link} password={password} transferId={transferId}/>
          }
        </div>
        <Footer />
      </div>
    </div>
  );
}

export default Home;